// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3rqpg","col":"CardReaderDesc_col__dPCOc","label":"CardReaderDesc_label__1eNpH"};